import React, { useLayoutEffect, useRef } from "react";
import SendIcon from "@mui/icons-material/Send";
import StopIcon from "@mui/icons-material/Stop";
import { useTranslation } from "react-i18next";

const MAX_HEIGHT = 220; // px the box grows to with its text, then it scrolls
export const MAX_QUESTION = 4000; // characters, as the API takes

// The question box: Enter sends, Shift + Enter starts a new line, Esc stops the answer being written
export default function Composer({ text, onText, onSend, onStop, running, stopping, busy, rows = 1, placeholder, autoFocus }) {
  const { t } = useTranslation();
  const box = useRef(null);

  // as tall as its text, from rows lines
  useLayoutEffect(() => {
    const el = box.current;
    el.style.height = "auto";
    el.style.height = Math.min(el.scrollHeight, MAX_HEIGHT) + "px";
  }, [text, rows]);

  const canSend = !running && !busy && text.trim() !== "";
  const send = () => canSend && onSend();
  const onKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey && !e.nativeEvent.isComposing) {
      e.preventDefault();
      send();
    } else if (e.key === "Escape" && running && !stopping) {
      e.preventDefault();
      onStop();
    }
  };

  return (
    <form
      className={"ak-composer" + (rows > 1 ? " is-big" : "")}
      onSubmit={(e) => {
        e.preventDefault();
        send();
      }}
    >
      <label htmlFor="ak-msg" className="ak-sr">
        {t("Message")}
      </label>
      <textarea
        id="ak-msg"
        ref={box}
        className="ak-input"
        rows={rows}
        value={text}
        maxLength={MAX_QUESTION}
        placeholder={placeholder}
        autoFocus={autoFocus}
        onChange={(e) => onText(e.target.value)}
        onKeyDown={onKeyDown}
      />
      <div className="ak-composer-row">
        <span className="ak-hint">{running ? t("Esc to stop") : t("Enter to send · Shift + Enter for a new line")}</span>
        {running ? (
          <button type="button" className="ak-send is-on" aria-label={t("Stop")} title={t("Stop")} disabled={stopping} onClick={onStop}>
            <StopIcon />
          </button>
        ) : (
          <button type="submit" className={"ak-send" + (canSend ? " is-on" : "")} aria-label={t("Send")} title={t("Send")} disabled={!canSend}>
            <SendIcon />
          </button>
        )}
      </div>
    </form>
  );
}
